// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"dg-z","sponsoredTooltipWrapper":"eg-z","sponsoredTooltip":"fg-z","newCard":"gg-z"};